import type { ProfileData } from '../types/profile.types';
import { generateYearContributions, calculateTotalContributions } from './contributionUtils';
import { UserRole } from '@practium/shared';

export const mapMeToProfileData = (me: any): ProfileData => {
	const contributions = generateYearContributions(2025);

	const formatZipCode = (zip: string): string => zip?.replace(/(\d{5})(\d{3})/, '$1-$2') ?? '';

	const formatPhoneNumber = (phone: string): string => {
		const digits = phone?.replace(/\D/g, '') ?? '';
		const local = digits.length > 11 ? digits.slice(-11) : digits;
		return local.replace(/(\d{2})(\d{5})(\d{4})/, '($1) $2-$3');
	};

	const totalContributions = calculateTotalContributions(contributions);

	const planMapping: Record<
		string,
		{
			name: string;
			description: string;
			canUpgrade: boolean;
			upgradeTo?: string;
		}
	> = {
		[UserRole.Consultant]: {
			name: 'Business',
			description: 'Sua experiência Business está ativa e otimizada',
			canUpgrade: true,
			upgradeTo: 'Enterprise',
		},

		[UserRole.Company]: {
			name: 'Enterprise',
			description: 'Ecossistema Otimizado: Gestão completa com nível máximo de recursos',
			canUpgrade: false,
		},

		[UserRole.Farmer]: {
			name: 'Professional',
			description: 'Sua experiência Professional está ativa e otimizada',
			canUpgrade: true,
			upgradeTo: 'Business',
		},
	};

	const role = me.role === 'admin' ? UserRole.Company : (me.role as UserRole);

	const planConfig = planMapping[role] || planMapping[UserRole.Farmer];

	return {
		user: {
			_id: me._id,
			name: me.name,
			surName: me.surName,
			email: me.email,
			phoneNumber: formatPhoneNumber(me.phoneNumber),
			document: me.document,
			documentType: me.documentType,
			role,
			isMaster: me.isMaster,
			hierarchyLevel: me.hierarchyLevel,
			status: true,

			avatar: me.avatar?.url
				? { provider: me.avatar.provider ?? 'local', url: me.avatar.url }
				: undefined,

			background: me.background?.url
				? { provider: me.background.provider ?? 'local', url: me.background.url }
				: undefined,

			address: me.address
				? {
						street: me.address.street,
						district: me.address.district,
						city: me.address.city,
						state: me.address.state,
						zipCode: formatZipCode(me.address.zipCode),
						number: me.address.number,
					}
				: undefined,
		},

		stats: {
			yearsOfUse: 4,
			frequentUsageYears: 4,
			dailySessions: 75,
			activeDays: 274,
			activeDaysPercentage: 75,
		},

		contributions: {
			totalContributions,
			percentile: 1,
			contributions,
		},

		plan: {
			name: planConfig.name,
			description: planConfig.description,
			validUntil: '26 Ago, 2026',
			canUpgrade: planConfig.canUpgrade,
			upgradePlanName: planConfig.upgradeTo,
		},
	};
};
